import { setAlertMessage } from "state/slices/alertSlice";

const callApi = async (
  endpoint,
  method = "GET",
  data = null,
  stringifyData = true,
  auth_required = true,
  dispatch = () => {},
  navigate = () => { },
  headers = {
    "Content-Type": "application/json",
  }
) => {
  if (headers === null || headers === undefined) headers = {};
  if (auth_required) {
    headers["Authorization"] = `Bearer ` + localStorage.getItem("token");
  }
  try {
    const options = {
      method,
      headers: headers,
    };
    if (data) {
      options.body = stringifyData ? JSON.stringify(data) : data;
    }
    const response = await fetch(
      `${process.env.REACT_APP_API}${endpoint}`,
      options
    );
    if (!response.ok) {
      if (response.status === 405) {
        dispatch(setAlertMessage("Method not allowed"));
      } else if (response.status !== 401) {
        const errorData = await response.json();
        if (errorData?.errorMessage)
          dispatch(setAlertMessage(errorData?.errorMessage));
        else dispatch(setAlertMessage("Resource not found"));
      } else if (response.status === 401) {
        const errorData = await response.json();
        dispatch(
          setAlertMessage(
            errorData?.errorMessage
              ? errorData?.errorMessage
              : "Unauthorized access"
          )
        );
      } else {
        dispatch(
          setAlertMessage(
            endpoint === "/" || endpoint === "auth/login"
              ? "Bad Credentials"
              : "Please login!"
          )
        );
      }
      return { body: null, success: false };
    }

    return { body: await response.json(), success: true };
  } catch (error) {
  if (
    error.message === "Failed to fetch" ||
    error.message === "NetworkError"
  ) {
    if (typeof navigate === "function") {
      navigate("/maintainance");
    }
  } else {
    if (typeof navigate === "function") {
      navigate("/");
    }
    dispatch(setAlertMessage("Please login again."));
  }

  return { body: null, success: false };
}
};

export default callApi;
